import { render, staticRenderFns } from "./userGroupChoose.vue?vue&type=template&id=040fec40&scoped=true&"
import script from "./userGroupChoose.vue?vue&type=script&lang=ts&"
export * from "./userGroupChoose.vue?vue&type=script&lang=ts&"
import style0 from "./userGroupChoose.vue?vue&type=style&index=0&id=040fec40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fec40",
  null
  
)

export default component.exports